import _parseInt from "@babel/runtime-corejs2/core-js/parse-int";
import "core-js/modules/es6.array.find";
import _extends from "@babel/runtime-corejs2/helpers/esm/extends";
import _classCallCheck from "@babel/runtime-corejs2/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime-corejs2/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs2/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime-corejs2/helpers/esm/inherits";
import _assertThisInitialized from "@babel/runtime-corejs2/helpers/esm/assertThisInitialized";
import _taggedTemplateLiteral from "@babel/runtime-corejs2/helpers/esm/taggedTemplateLiteral";

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n    display: none;\n  "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n    display: none;\n  "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: ", "px;\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    justify-content: space-between;\n    height: 136px;\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import * as React from 'react';
import styled from 'styled-components';
import { ComponentSwitch, Box } from '@origin-digital/layout';
import { Colors, Heading2, Heading4, Text } from '@origin-digital/style-guide';
import { MobileNavButton } from './MobileNavButton';
import { AddressLine } from './AddressLine';
import { FullSelect, CompactSelect } from './PropertySelect';
import { BREAK_POINTS, breakPoint, LG } from '@origin-digital/helper';
var ActionBarContainer = styled.div.withConfig({
  displayName: "ActionBar__ActionBarContainer",
  componentId: "sc-16wkjeb-0"
})(["background-color:", ";display:flex;flex-direction:column;flex:1;"], Colors.WHITE);
var ViewContainer = styled.div.withConfig({
  displayName: "ActionBar__ViewContainer",
  componentId: "sc-16wkjeb-1"
})(["display:flex;align-items:center;justify-content:center;background-color:", ";height:44px;width:100%;", ""], Colors.WHITE, LG(_templateObject()));
var ActionBarTitleMobile = styled(Heading4).withConfig({
  displayName: "ActionBar__ActionBarTitleMobile",
  componentId: "sc-16wkjeb-2"
})(["font-size:14px !important;"]);
var SELECT_LABEL_OFFSET_PX = 54;
var DesktopPremiseSelectContainer = styled.div.withConfig({
  displayName: "ActionBar__DesktopPremiseSelectContainer",
  componentId: "sc-16wkjeb-3"
})(["display:none;", ""], function () {
  return breakPoint('LG', BREAK_POINTS.LG.Min)(_templateObject2(), function (props) {
    return props.width + SELECT_LABEL_OFFSET_PX;
  });
});
var FullMobilePremiseSelectContainer = styled.div.withConfig({
  displayName: "ActionBar__FullMobilePremiseSelectContainer",
  componentId: "sc-16wkjeb-4"
})(["height:48px;display:flex;padding-left:16px;padding-right:12px;align-items:center;justify-content:center;border-top:1px solid ", ";", ""], Colors.GREY16, LG(_templateObject3()));
var CompactMobilePremiseSelectContainer = styled.div.withConfig({
  displayName: "ActionBar__CompactMobilePremiseSelectContainer",
  componentId: "sc-16wkjeb-5"
})(["display:flex;align-items:center;position:absolute;height:44px;width:52px;top:0;right:2px;cursor:pointer;overflow:hidden;", ""], LG(_templateObject4()));
var HiddenLabelStyle = {
  fontSize: 12,
  position: 'fixed',
  top: 0,
  left: 0,
  visibility: 'hidden'
};
export var ActionBar =
/*#__PURE__*/
function (_React$Component) {
  _inherits(ActionBar, _React$Component);

  function ActionBar(props) {
    var _this;

    _classCallCheck(this, ActionBar);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ActionBar).call(this, props));

    _this.getSelectProps = function () {
      var _this$props = _this.props,
          premises = _this$props.premises,
          selectedPremiseId = _this$props.selectedPremiseId;
      var premiseOptions = premises.map(function (premise) {
        return {
          label: premise.premiseName,
          value: premise.premiseId
        };
      });
      return {
        options: premiseOptions,
        selectedValue: selectedPremiseId,
        onChange: function onChange(event) {
          return _this.handleOnSelectPremise(event.target.value);
        }
      };
    };

    _this.addressPlaceholderRef = React.createRef();
    _this.getAddressPlaceholderRef = _this.getAddressPlaceholderRef.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.handleOnSelectPremise = _this.handleOnSelectPremise.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.state = {
      selectedAddressText: '',
      fontsLoaded: false
    };
    return _this;
  }

  _createClass(ActionBar, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      // If documents.fonts is supported, re-render select width when fonts have loaded
      // Document.fonts not currently supported by typescript
      if (document['fonts']) {
        document['fonts'].ready.then(function () {
          _this2.calcSelectWidth();
        });
      } // Calculate select width using default browser font


      this.calcSelectWidth();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var selectedPremise = this.getSelectedPremise();

      if (selectedPremise && selectedPremise.premiseName !== this.state.selectedAddressText) {
        this.setState({
          selectedAddressText: selectedPremise.premiseName
        });
      } // Re-calculate size after the hidden label has rendered


      this.calcSelectWidth();
    } // Calculate the width of the address label and set state

  }, {
    key: "calcSelectWidth",
    value: function calcSelectWidth() {
      if (this.getAddressPlaceholderRef().current) {
        var selectedLabelWidthPx = this.getAddressPlaceholderRef().current.offsetWidth;

        if (selectedLabelWidthPx !== this.state.selectedLabelWidthPx) {
          this.setState({
            selectedLabelWidthPx: selectedLabelWidthPx
          });
        }
      }
    }
  }, {
    key: "handleOnSelectPremise",
    value: function handleOnSelectPremise(premiseId) {
      var onSelectPremise = this.props.onSelectPremise;
      var selectedProperty = this.getSelectedPremise(); // If a different address is selected, render the new label to get width

      if (this.state.selectedAddressText !== selectedProperty.premiseName) {
        this.setState({
          selectedAddressText: selectedProperty.premiseName
        });
      }

      onSelectPremise && onSelectPremise(premiseId);
    }
  }, {
    key: "getAddressPlaceholderRef",
    value: function getAddressPlaceholderRef() {
      return this.addressPlaceholderRef;
    }
  }, {
    key: "getDesktopPropertySelector",
    value: function getDesktopPropertySelector() {
      var _this$props2 = this.props,
          mobilePropertySelector = _this$props2.mobilePropertySelector,
          premises = _this$props2.premises,
          selectedPremiseId = _this$props2.selectedPremiseId;
      var selectedLabelWidthPx = this.state.selectedLabelWidthPx;

      if (mobilePropertySelector === 'none' || this.isEmptyPremise() || !this.hasSelectedPremise()) {
        return null;
      }

      if (mobilePropertySelector === 'readOnly' || this.isSinglePremise()) {
        return React.createElement(DesktopPremiseSelectContainer, {
          width: selectedLabelWidthPx
        }, React.createElement(AddressLine, {
          address: this.getSelectedPremise().premiseName
        }));
      }

      return React.createElement(DesktopPremiseSelectContainer, {
        width: selectedLabelWidthPx,
        "data-id": "actionbar-address-select-desktop-container"
      }, React.createElement(FullSelect, _extends({
        "data-id": "actionbar-address-select-full-desktop",
        width: this.state.selectedLabelWidthPx
      }, this.getSelectProps())));
    }
  }, {
    key: "getMobilePropertySelector",
    value: function getMobilePropertySelector() {
      var mobilePropertySelector = this.props.mobilePropertySelector;

      if (mobilePropertySelector === 'none' || mobilePropertySelector === 'readOnly' || this.isSinglePremise() || this.isEmptyPremise() || !this.hasSelectedPremise()) {
        return null;
      }

      if (mobilePropertySelector === 'compact') {
        return React.createElement(CompactMobilePremiseSelectContainer, {
          "data-id": "actionbar-address-select-compact-mobile-container"
        }, React.createElement(CompactSelect, _extends({
          "data-id": "actionbar-address-select-compact-mobile"
        }, this.getSelectProps())));
      }

      return React.createElement(FullMobilePremiseSelectContainer, null, React.createElement(FullSelect, _extends({
        "data-id": "actionbar-address-select-full-mobile"
      }, this.getSelectProps())));
    }
  }, {
    key: "isEmptyPremise",
    value: function isEmptyPremise() {
      return this.props.premises.length === 0;
    }
  }, {
    key: "isSinglePremise",
    value: function isSinglePremise() {
      return this.props.premises.length === 1;
    }
  }, {
    key: "getSelectedPremise",
    value: function getSelectedPremise() {
      var _this3 = this;

      return this.props.premises.find(function (premise) {
        return premise.premiseId === _this3.props.selectedPremiseId;
      });
    }
  }, {
    key: "hasSelectedPremise",
    value: function hasSelectedPremise() {
      return this.getSelectedPremise() !== undefined;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          title = _this$props3.title,
          mobileNavButton = _this$props3.mobileNavButton,
          onClickMobileNavButton = _this$props3.onClickMobileNavButton,
          headingComponent = _this$props3.headingComponent;

      var accessibilityLevel = _parseInt(headingComponent[1]);

      return React.createElement(React.Fragment, null, React.createElement("div", {
        "data-id": "hidden-address-label",
        style: HiddenLabelStyle,
        ref: this.addressPlaceholderRef
      }, React.createElement(Text, {
        size: "xs"
      }, this.state.selectedAddressText)), React.createElement(ActionBarContainer, {
        "data-id": "action-bar"
      }, React.createElement(ViewContainer, null, React.createElement(MobileNavButton, {
        onClick: onClickMobileNavButton,
        type: mobileNavButton
      }), React.createElement(ComponentSwitch, {
        breakpoint: "LG",
        showGreaterOrEqualTo: React.createElement(Heading2, {
          "data-id": "actionbar-heading-desktop",
          accessibilityLevel: accessibilityLevel,
          text: title
        }),
        showLessThan: React.createElement(ActionBarTitleMobile, {
          "data-id": "actionbar-heading-mobile",
          accessibilityLevel: accessibilityLevel,
          text: title
        })
      }), React.createElement(Box, {
        "data-id": "desktop-container"
      }, this.getDesktopPropertySelector())), React.createElement(Box, {
        "data-id": "mobile-container"
      }, this.getMobilePropertySelector())));
    }
  }]);

  return ActionBar;
}(React.Component);
ActionBar.defaultProps = {
  mobileNavButton: 'none',
  mobilePropertySelector: 'compact',
  premises: [],
  headingComponent: 'h1'
};